export enum CustomerType {
    Individual = "Individual",
    Corporate = "Corporate",
    Unknown = "Unknown"
}